<div
  class="wizard-header"
  role="tablist"
  [attr.aria-orientation]="orientation"
>
  @for (step of steps; track step; let index = $index) {
    @let done = step.completed && !step.isSelected();
    <div
      class="wizard-step-header"
      cdkStepHeader
      [class.selected]="step.isSelected()"
      [class.done]="done"
      [class.navigable]="step.isNavigable() && !step.isSelected()"
      [id]="_getStepLabelId(index)"
      [tabIndex]="_getFocusIndex() === index ? 0 : -1"
      [attr.aria-selected]="step.isSelected()"
      [attr.aria-controls]="_getStepContentId(index)"
      [attr.aria-posinset]="index + 1"
      [attr.aria-setsize]="steps.length"
      [attr.aria-disabled]="step.isNavigable() ? null : true"
      [attr.aria-label]="step.ariaLabel || null"
      (click)="selectStep(step)"
      (keydown)="_onKeydown($event)"
    >
      <span
        class="step-indicator"
        aria-hidden="true"
      >
        @if (done) {
          <mat-icon>check</mat-icon>
        } @else {
          {{ index + 1 }}
        }
      </span>
      <span class="step-text">
        @if (showStepNumber()) {
          <span class="step-title">Step {{ index + 1 }}</span>
          <span class="step-label">{{ step.label }}</span>
        } @else {
          <span class="step-title">{{ step.label }}</span>
        }
        @if (step.description()) {
          <span class="step-label">{{ step.description() }}</span>
        }
        @if (step.optional) {
          <span class="step-optional">Optional</span>
        }
      </span>
    </div>
    @if (!$last) {
      <div class="step-line"></div>
    }
  }
</div>

<div class="wizard-body">
  @for (step of steps; track step; let index = $index) {
    <div
      class="wizard-content"
      role="tabpanel"
      [id]="_getStepContentId(index)"
      [attr.aria-labelledby]="_getStepLabelId(index)"
      [hidden]="!step.isSelected()"
    >
      <ng-container [ngTemplateOutlet]="step.content" />
    </div>
  }
</div>
